module.exports = __webpack_public_path__ + "img/item5-1.535aa9d3.jpg";